import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: "none"
        },
      },
    }
  },
  palette: {
    primary: {
      main: "#5175FC",
      "100": "#152B43",
      "90": "#143153",
      "80": "#114581",
      "70": "#0E59B0",
      "60": "#0B6DDF",
      "50": "#4F96E8",
      "40": "#8AB9F0",
      "30": "#C4DCF7",
      "20": "#D8E8FA",
      "10": "#EBF3FC",
      "05": "#F5F9FE"
    },
    error: {
      main: "#CE5E5E",
      "100": "#391B1D",
      "90": "#461B1D",
      "80": "#6D1D1E",
      "70": "#941E1E",
      "60": "#BB1F1F",
      "50": "#CE5E5E",
      "40": "#DE9393",
      "30": "#EFC9C9",
      "20": "#F4DBDB",
      "10": "#FAEDED",
    },
    warning: {
      main: "#F1C557",
      "100": "#42381B",
      "90": "#53441A",
      "80": "#866718",
      "70": "#B88B17",
      "60": "#EBAF15",
      "50": "#F1C557",
      "40": "#F5D98F",
      "30": "#FAECC7",
      "20": "#FCF2DA",
      "10": "#FDF9EC",
    },
    success: {
      main: "#62A260",
      "100": "#1B2E1D",
      "90": "#1C361E",
      "80": "#1F4E1F",
      "70": "#226621",
      "60": "#257E22",
      "50": "#62A260",
      "40": "#96C195",
      "30": "#CBE0CA",
      "20": "#DCEADC",
      "10": "#EEF5ED",
    },
    black_solid: {
      "100": "#181A1C",
      "90": "#2F3133",
      "80": "#464849",
      "70": "#5D5F60",
      "60": "#747677",
      "50": "#A3A3A4",
      "40": "#BABABB",
      "30": "#D1D1D2",
      "20": "#E8E8E8",
      "10": "#F3F4F4",
      "05": "#FAFAFA"
    },
    black_opacity: {
      "100": "#181A1C",
      "90": "#181A1C90",
      "80": "#181A1CCC",
      "70": "#181A1CB2",
      "60": "#181A1C60",
      "50": "#181A1C50",
      "40": "#181A1C40",
      "30": "#181A1C30",
      "20": "#181A1C20",
      "10": "#181A1C10",
      "05": "#181A1C05"
    },
    white_opacity: {
      "100": "#FFFFFF",
      "90": "#FFFFFF90",
      "80": "#FFFFFF80",
      "70": "#FFFFFF70",
      "60": "#FFFFFF60",
      "50": "#FFFFFF50",
      "40": "#FFFFFF40",
      "30": "#FFFFFF30",
      "20": "#FFFFFF20",
      "10": "#FFFFFF10",
      "05": "#FFFFFF05"
    },
    purple: {
      "100": "#301935",
      "90": "#3A193E",
      "80": "#57175C",
      "70": "#751679",
      "60": "#921597",
      "50": "#B157B4",
      "40": "#CB8FCD",
      "30": "#E5C7E6",
      "20": "#EEDAEE",
      "10": "#F6ECF7"
    },
    orange: {
      "100": "#3D2317",
      "90": "#4C2615",
      "80": "#793010",
      "70": "#A53B0A",
      "60": "#D24504",
      "50": "#DF794A",
      "40": "#E9A687",
      "30": "#F4D2C3",
      "20": "#F8E1D7",
      "10": "#FBF0EB"
    },
    cherry: {
      "100": "#341B20",
      "90": "#3F1C22",
      "80": "#601D27",
      "70": "#821F2C",
      "60": "#A32031",
      "50": "#BD5E6B",
      "40": "#D3949C",
      "30": "#E9C9CE",
      "20": "#F0DBDE",
      "10": "#F8EDEF"
    },
    teal: {
      "100": "#212E31",
      "90": "#25353A",
      "80": "#2F4D54",
      "70": "#3A646D",
      "60": "#457C87",
      "50": "#79A1A9",
      "40": "#A6C0C5",
      "30": "#D2E0E2",
      "20": "#E1EAEC",
      "10": "#F0F5F5"
    },
    gold: {
      "100": "#302C20",
      "90": "#393321",
      "80": "#554826",
      "70": "#725E2A",
      "60": "#8E732F",
      "50": "#AE9A69",
      "40": "#C9BC9B",
      "30": "#E4DDCD",
      "20": "#EDE9DE",
      "10": "#F6F4EE"
    },
    magenta:{
      "100": "#3A1932",
      "90": "#48193B",
      "80": "#48193B",
      "70": "#9B1870",
      "60": "#C4178B",
      "50": "#D458AB",
      "40": "#E390C7",
      "30": "#F1C7E3",
      "20": "#F6DAEC",
      "10": "#FAECF6"
    }
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
    title: {
      fontWeight: "200",
      fontSize: "56px",
      lineHeight: "60px"
    },
    //Page Title
    h1: {
      fontWeight: 600,
      fontSize: "24px",
      lineHeight: "32px",
    },
    //Header
    h2: {
      fontWeight: 600,
      fontSize: "20px",
      lineHeight: "28px"
    },
    //Sub-header
    h3: {
      fontWeight: 500,
      fontSize: "18px",
      lineHeight: "24px"
    },
    //Navigation links, side menu headers, and buttons
    h4: {
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "24px"
    },
    //Table-header
    subhead1: {
      fontWeight: 700,
      fontSize: "14px",
      lineHeight: "20px"
    },
    //Body-text
    subhead2: {
      fontWeight: 500,
      fontSize: "12px",
      lineHeight: "16px"
    },
    //Table text and field inputs
    body1: {
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px"
    },
    //Table text and field inputs
    body2: {
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "16px"
    },
    //Labels
    label1: {
      fontWeight: 500,
      fontSize: "11px",
      lineHeight: "12px",
      fontFamily: "Roboto, sans-serif"
    },
    label2: {
      fontWeight: 500,
      fontSize: "10px",
      lineHeight: "12px",
      fontFamily: "Roboto, sans-serif"
    },
    //Buttons
    button1: {
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "20px"
    },
    button2: {
      fontWeight: 500,
      fontSize: "12px",
      lineHeight: "20px"
    },
    //Helper text
    helperText: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px"
    }
  },
  shadows: {
    0: "none",
    1: "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
    2: "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
    3: "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
    4: "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
    5: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
    6: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
    7: "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
    8: "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
    9: "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
    10: "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
    11: "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
    12: "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
    13: "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
    14: "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
    15: "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
    16: "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
    17: "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
    18: "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
    19: "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
    20: "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
    21: "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
    22: "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
    23: "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
    24: "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
    elevation1: "0 1px 2px 0 rgba(24, 26, 28, 0.08), 0 2px 4px 0 rgba(24, 26, 28, 0.08)",
    elevation2: "0 1px 2px 0 rgba(24, 26, 28, 0.08), 0 4px 8px 0 rgba(24, 26, 28, 0.16)",
    elevation3: "0 1px 4px 0 rgba(24, 26, 28, 0.12), 0 8px 12px 0 rgba(24, 26, 28, 0.2)",
    elevation4: "0 1px 4px 0 rgba(24, 26, 28, 0.12), 0 12px 16px 0 rgba(24, 26, 28, 0.24)",
    elevation5: "0 3px 8px 0 rgba(24, 26, 28, 0.16), 0 16px 24px 0 rgba(24, 26, 28, 0.24)"
  }
});

export default theme;
